export function deepMerge<T>(target: Partial<T>, source: Partial<T>, ignoreKeys?: string[]): T {
    const result: any = { ...target };
    
    for (const key in source) {
      const isRefLike = (val: any) => val && typeof val === 'object' && 'current' in val;
      if (isRefLike((target as any)[key]) || isRefLike((source as any)[key])) {
        result[key] = source[key];
        continue;
      }

      if (source[key] instanceof Object && key in target && target[key] instanceof Object && !ignoreKeys?.includes(key)) {
        if (Array.isArray(source[key]) && Array.isArray(target[key])) {
          result[key] = (source[key] as any[]).map((item, index) => {
            if (item instanceof Object && index < (target[key] as any[]).length && (target[key] as any[])[index] instanceof Object) {
              return deepMerge((target[key] as any[])[index], item, ignoreKeys);
            }
            return item;
          });
        } else {
          result[key] = deepMerge(target[key] as any, source[key] as any, ignoreKeys);
        }
      } else {
        result[key] = source[key];
      }
    }
    
    return result as T;
}